// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bU7i","colMin":"styles_colMin__3Wv8N"};